"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusOptions = exports.rowsPerPageOptions = exports.meterTypeOptions = exports.meterLevelOptions = exports.columns = void 0;
var statusOptions = [
    { key: "all", label: "All" },
    { key: "active", label: "Active" },
    { key: "inactive", label: "Inactive" },
];
exports.statusOptions = statusOptions;
var meterTypeOptions = [
    { key: "all", label: "All Types" },
    { key: "Power", label: "Power" },
    { key: "Water", label: "Water" },
];
exports.meterTypeOptions = meterTypeOptions;
var meterLevelOptions = [
    { key: "all", label: "All Levels" },
    { key: "area", label: "Area Level" },
    { key: "building", label: "Building Level" },
];
exports.meterLevelOptions = meterLevelOptions;
var rowsPerPageOptions = [
    { key: "5", label: "5" },
    { key: "10", label: "10" },
    { key: "25", label: "25" },
    { key: "50", label: "50" },
    { key: "100", label: "100" },
];
exports.rowsPerPageOptions = rowsPerPageOptions;
var columns = [
    { name: "METER ID", uid: "meterId" },
    { name: "TYPE", uid: "meterType" },
    { name: "SERIAL NUMBER", uid: "serialNumber" },
    { name: "BUILDING", uid: "buildingName" },
    { name: "AREA", uid: "areaName" },
    { name: "TENANT", uid: "tenantName" },
    { name: "RESPONSIBLE PARTY", uid: "responsibleParty" },
    { name: "MAKE / MODEL", uid: "meterMakeModel" },
    { name: "KVA RATING", uid: "kvaRating" },
    { name: "READING TYPE", uid: "isManualReading" },
    { name: "STATUS", uid: "isActive" },
    { name: "ACTIONS", uid: "actions" },
];
exports.columns = columns;
